import { Box, CardMedia, Paper, Typography, useMediaQuery } from '@mui/material';
import Cookies from 'js-cookie';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { convertCurrency } from '../../../utils/convertCurrency';
import { useSelector } from 'react-redux';

export default function AboutLecture({ lectureData }) {
    const { t } = useTranslation();
    const lang = Cookies.get("i18next") || "en";
    const isMobile = useMediaQuery("(max-width:600px)");
    const { currency } = useSelector(state => state.currency);

    function convertDate(dateString) {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0]; // yyyy-mm-dd
    }
    const [convertedAmount, setConvertedAmount] = React.useState(null);
    React.useEffect(() => {
        async function fetchConvertedAmount() {
            const result = await convertCurrency(lectureData.price, lectureData.currency, currency);
            setConvertedAmount(result);
        }

        fetchConvertedAmount();
    }, [lectureData.price, currency, lectureData.currency]);
    return (
        <Paper sx={{ padding: isMobile ? "16px" : "32px 24px", marginY: "30px" }}>
            <CardMedia
                component="img"
                height="140"
                image={lectureData.image ? `${process.env.REACT_APP_API_KEY}images/${lectureData.image}` : "/logo.png"}
                alt="package img"
                sx={{ filter: "brightness(50%)", height: isMobile ? "250px" : "400px", width: "100%", objectFit: "cover" }}
            />
            <Box sx={{ textAlign: "center", marginY: "8px",marginBottom:"2rem" }}>
                <Typography variant={isMobile ? "h5" : "h4"} sx={{ fontWeight: "700" }}>
                    {lang === "ar" ? lectureData.titleArabic : lectureData.titleEnglish}
                </Typography>
            </Box>

            {/** معلومات المحاضرة **/}
            {[
                { label: t("description"), value: lang === "ar" ? lectureData.descriptionArabic : lectureData.descriptionEnglish },
                { label: t("studycurriculums"), value: lang === "ar" ? lectureData?.curriculums?.titleAR : lectureData?.curriculums?.titleEN },
                { label: t("subject"), value: lang === "ar" ? lectureData.subject.titleAR : lectureData.subject.titleEN },
                { label: t("classes"), value: lang === "ar" ? lectureData?.class?.titleAR : lectureData?.class?.titleEN },
                { label: t("semester"), value: t(lectureData?.semester) },
                { label: t("price"), value: convertedAmount },
                { label: t("currency"), value: t(currency) },
            ].map((item, index) => (
                <Box
                    key={index}
                    sx={{
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: "10px",
                        gap: isMobile ? "8px" : "0"
                    }}
                >
                    <Typography
                        variant="body1"
                        sx={{
                            fontWeight: "700",
                            background: "#f2f3f4",
                            borderRadius: "1rem",
                            padding: isMobile ? "0.8rem 2rem" : "1rem 5rem",
                            width: isMobile ? "100%" : "300px",
                            textAlign: "center"
                        }}
                    >
                        {item.label}
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            fontWeight: "400",
                            background: "#f2f3f4",
                            borderRadius: "1rem",
                            padding: isMobile ? "0.8rem 2rem" : "1rem 5rem",
                            width: isMobile ? "100%" : "300px",
                            textAlign: "center",
                            color: "#5dade2"
                        }}
                    >
                        {item.value}
                    </Typography>
                </Box>
            ))}
        </Paper>
    );
}
